import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e8f4e6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "webviewer",
  ref: "viewer"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, null, 512))
}